import React from "react";
import "./challenge.css";
import AnimatedNumber from "../Team/animatednumber";
// import persianowner from "../../images/CaseStudy/persianimages/Persianowner.webp";
// import persianowner from "../../images/CaseStudy/silverbeachcafe/silverbeachcafeowner.png";

const ImpactSection = ({impact}) => {
//   const impactCards = {
//     card1: {
//       header: "Revenue",
//       figures: 75,
//       figuresPostfix: "%",
//       content: "growth in Appetizer Revenue Share",
//     },
//     card2: {
//       header: "Conversion",
//       figures: 34,
//       figuresPostfix: "%",
//       content: "increase in Menu-to-Order conversions",
//     },
//     card3: {
//       header: "Ads Conversion",
//       figures: 57,
//       figuresPostfix: "%",
//       content: "increase in Ads Menu-to-Order conversions",
//     },
//   };
  const impactCards = impact.impactCards

  return (
    <div className="challenge">
      <div>
        <h3> Impact</h3>
        <hr></hr>
      </div>
      <div className="impact-cards">
        {Object.keys(impactCards).map((key) => {
          const card = impactCards[key];
          return (
            <div className="impact-single-card">
              <div className="impact-card-header">{card.header}</div>
              <div className="impact-card-figure">
                {" "}
                <AnimatedNumber
                  end={card.figures}
                  duration={3}
                  unit={card.figuresPostfix}
                />{" "}
              </div>
              <div className="impact-card-content">{card.content}</div>
            </div>
          );
        })}
      </div>

      <div className="impact-section">
        <div className="impact-left-section">
          <h1>{impact.owner_views.title}</h1>
          <p>
            {impact.owner_views.description}
          </p>
          <div className="writer-name">
            <h3>{impact.owner_views.name}</h3>
            <span>{impact.owner_views.designation}</span>
          </div>
        </div>

        {/* <img src={persianowner} className="impact-img"></img> */}
        <img src={impact.owner_views.owner_img} className="impact-img"></img>
      </div>
    </div>
  );
};

export default ImpactSection;
